import { AreaRangeGraphData, LineGraphData, PlotlineConfigInput } from '@navstation-portal/shared/data-model/charts';

export type CiiDataPoint = {
  date: number;
  attained: number;
  required: number;
  average: number;
  co2: number;
  distance: number;
};

export type CiiChartData = {
  yMarkers: PlotlineConfigInput;
  ciiLifetimeData: LineGraphData;
  ciiAreaData: AreaRangeGraphData;
};

export const CII_COLORS = {
  green: 'rgba(0, 255, 0, 0.4)',
  lightGreen: 'rgba(173, 255, 47, 0.4)',
  yellow: 'rgba(255, 215, 0, 0.4)',
  orange: 'rgba(255, 99, 71, 0.4)',
  red: 'rgba(255, 0, 0, 0.4)',
};

export const BASE_CII_LIMITS: AreaRangeGraphData = [
  { name: 'A', type: 'arearange', zIndex: 0, color: CII_COLORS.green, data: [] },
  { name: 'B', type: 'arearange', zIndex: 0, color: CII_COLORS.lightGreen, data: [] },
  { name: 'C', type: 'arearange', zIndex: 0, color: CII_COLORS.yellow, data: [] },
  { name: 'D', type: 'arearange', zIndex: 0, color: CII_COLORS.orange, data: [] },
  { name: 'E', type: 'arearange', zIndex: 0, color: CII_COLORS.red, data: [] },
];

export type CiiRating = 'A' | 'B' | 'C' | 'D' | 'E';
